import { createAction } from '@reduxjs/toolkit';

const toggleGift = createAction('giftToggle/toggleGift');
export default toggleGift;
